import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { gspNewVersion, isCsairApp } from '@csair/emp-helpers';

export default store => ({
  path: Routes.ticket.child.wrongPurchase.key,
  onEnter(nextState, replace, callback) {
    // gspNewVersion(['错购申请页面', '072-0060-23028-12201'], {
    //   1: '页面曝光一次触发一次',
    //   2: '国双新版',
    //   3: isCsairApp() ? 'App' : 'Mobile',
    // });
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: '机票退改-错购提交申请页',
      channel_id: '',
    });
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const wrongPurchase = require('./components/wrongPurchase').default;
        cb(null, wrongPurchase);
      },
      'wrongPurchase'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/wrongPurchase/index.js